const base = {
	black: "#1f1f1f",
	white: "#ffffff",
};

const messages = {
	error: "#C4371C",
	success: "#63b893",
	warning: "#ffd943",
};

const cneAreas = {
	yellow: "#eee809",
	limeGreen: "#a6ce3a",
	purple: "#812990",
	pink: "#ed0c6e",
	highlighterYellow: "#E3E40F"
};

const gradients = {
	background: "linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(0deg, #ed0c6e 18.2%, #812990 100%)",
	purple: "linear-gradient(82.67deg, #97c93a 5.42%, #97c93a 5.43%, #eee809 94.75%)",
	orange: "linear-gradient(125.81deg, #e8e60e 6.89%, #e60e71 77.73%)",
	pink: "linear-gradient(98.51deg, #ee3d96 4.29%, #ee3286 27.65%, #ed145b 97.74%)",
	green: "linear-gradient(82.67deg, #97c93a 5.42%, #97c93a 5.43%, #eee809 94.75%)",
	datePickerGradient:  "linear-gradient( 98.51deg, #ee3d9690 4.29%, #ee328690 27.65%, #ed145b90 97.74%)"
}

const Colors = {
	base,
	messages,
	cneAreas,
	gradients
};

export default Colors;
